import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Box from '../Box';
export var TableHead = /*#__PURE__*/React.forwardRef(function TableHead(props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "thead",
    ref: ref
  }, props));
});
export default TableHead;